(function () {

	angular.module('qbePortal').controller('QBCurrency', QBCurrency);

	QBCurrency.$inject = ['$scope'];

	function QBCurrency($scope) {
		var vm = this;

		vm.fieldValue = null;
		//vm.dateOfBirth = new Date(1991, 3, 21); // To be replaced with date from DOB field

		//console.log(vm.dob);

		vm.registerHierarchy = function (name, setHierarchyFn) {
			vm.setHierarchy({name: name, setHierarchyFn: setHierarchyFn});
		}

		vm.onValueChanged = function () {
			vm.update({name: vm.name, value: vm.fieldValue});
		}
	}

	angular.module('qbePortal').component('qbCurrency', {
		templateUrl: '../ngviews/components/qbCurrency.html',
		controller: QBCurrency,
		controllerAs: 'vm',
		bindings: {
			name: '@',
			update: '&',
			setHierarchy: '&',
		}
	});
})();
